import { TicketRepository } from '../repositories/TicketRepository'

export function CreateSubAreaCase(ticketRepository: TicketRepository) {
  return async function ({ areaId, data }) {
    return await ticketRepository.createSubArea({ areaId, data })
  }
}
